import { combineReducers } from '@reduxjs/toolkit';
import loginReducer from './reducers/login';

const rootReducer = combineReducers({
  auth: loginReducer
});

export default rootReducer;